import { useCallback } from "react";
import { useUserToken } from "@/features/auth/hooks/useUserToken";
import * as Session from "@/features/auth/services/session";
import { toast } from "@picklebet/ui";
import { getDeviceId } from "utilities/getDeviceId";

// Non-OK responses resolve with the parsed body rather than throwing;
// 401/403 tears down the session.
const useApiFetch = () => {
  const token = useUserToken();

  return useCallback(
    async <T>(url: string): Promise<T> => {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-DeviceId": getDeviceId(),
        },
      });

      if (response.status === 401 || response.status === 403) {
        Session.handleUnauthorized();

        toast({
          description: "Your session has expired, please log in again.",
        });
      }

      return response.json();
    },
    [token],
  );
};

export { useApiFetch };
